var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconawesomeFilePrescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-prescription",
    "data-name": "Icon awesome-file-prescription",
    d: "M12.833,7.438V0H1.375A1.342,1.342,0,0,0,0,1.313V26.688A1.342,1.342,0,0,0,1.375,28h19.25A1.342,1.342,0,0,0,22,26.688V8.75H14.208A1.349,1.349,0,0,1,12.833,7.438Zm3.926,9.815.648.619a.847.847,0,0,1,0,1.238l-1.713,1.635,1.722,1.644a.847.847,0,0,1,0,1.238l-.648.619a.948.948,0,0,1-1.3,0L13.75,22.6l-1.722,1.644a.948.948,0,0,1-1.3,0l-.648-.619a.847.847,0,0,1,0-1.238l1.722-1.644L8.407,17.5H7.333v2.625A.9.9,0,0,1,6.417,21H5.5a.9.9,0,0,1-.917-.875v-8.75A.9.9,0,0,1,5.5,10.5h4.583A3.586,3.586,0,0,1,13.75,14a3.468,3.468,0,0,1-1.917,3.058l1.917,1.83,1.713-1.635A.948.948,0,0,1,16.76,17.253Zm-6.676-2.378H7.333v-1.75h2.75a.876.876,0,1,1,0,1.75ZM22,6.666V7H14.667V0h.349a1.408,1.408,0,0,1,.974.383L21.6,5.742A1.279,1.279,0,0,1,22,6.666Z",
    fill: "#124e61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeFilePrescription);
export default __webpack_public_path__ + "static/media/Icon awesome-file-prescription.fa0d8c4e2b95a0338cde9af2515141aa.svg";
export { ForwardRef as ReactComponent };